import api from "../axios";

let disciplinesCache = null;
let disciplinesPromise = null;

export const invalidateDisciplinesCache = () => {
  disciplinesCache = null;
  disciplinesPromise = null;
};

/**
 * Get all available disciplines (templates and company-specific)
 */
export const getDisciplines = async ({ force = false } = {}) => {
  if (!force && disciplinesCache) {
    return disciplinesCache;
  }

  if (!force && disciplinesPromise) {
    return disciplinesPromise;
  }

  disciplinesPromise = api.get("/disciplines").then((response) => {
    disciplinesCache = response.data;
    disciplinesPromise = null;
    return disciplinesCache;
  }).catch((error) => {
    disciplinesPromise = null;
    throw error;
  });

  return disciplinesPromise;
};

/**
 * Get a specific discipline by ID
 */
export const getDiscipline = async (id) => {
  const response = await api.get(`/disciplines/${id}`);
  return response.data;
};

/**
 * Load a template discipline to the company
 */
export const loadDisciplineToCompany = async (disciplineId) => {
  const response = await api.post(`/disciplines/${disciplineId}/load_to_company`);
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Create a new discipline for the company
 */
export const createDiscipline = async (data) => {
  const response = await api.post("/disciplines", { discipline: data });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Update a discipline
 */
export const updateDiscipline = async (id, data) => {
  const response = await api.patch(`/disciplines/${id}`, { discipline: data });
  invalidateDisciplinesCache();
  return response.data;
};

/**
 * Delete a discipline
 */
export const deleteDiscipline = async (id) => {
  const response = await api.delete(`/disciplines/${id}`);
  invalidateDisciplinesCache();
  return response.data;
};

// NOTE: Template discipline management functions will be implemented
// in a separate super-admin dashboard later. These functions are kept
// for future use but routes are not exposed yet.
